import React from 'react';
import { Box, Grid, styled } from '@mui/material';
import { LinkCore } from '../LinkCore/LinkCore';

interface TabItem {
  label: string;
  value: string;
  to: string;
}

interface CustomTabsProps {
  tabs: TabItem[];
  currentValue: string;
  onChange: (event: React.SyntheticEvent, newValue: string) => void;
}


export const CustomTabs: React.FC<CustomTabsProps> = ({
  tabs, currentValue, onChange
}) => {
  const TabsContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    backgroundColor: '#e0e0e0b6',
    padding: '4px',
    borderRadius: '8px',
    overflow: 'hidden',
    margin: '0 auto',
    minWidth: '100%',
  }));

  const TabButton = styled(Box)<{ isSelected: boolean }>(({ theme, isSelected }) => ({
    padding: '8px 16px',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    backgroundColor: isSelected ? '#3980F5' : '#d4d4d4',
    color: isSelected ? '#FFFFFF' : '#6C757D',
    fontWeight: 500,
    fontSize: '14px',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
    '&:hover': {
      backgroundColor: isSelected ? '#1E90FF' : '#E0E0E0',
    },
    '&:first-of-type': {
      borderTopLeftRadius: '8px',
      borderBottomLeftRadius: '8px',
    },
    '&:last-of-type': {
      borderTopRightRadius: '8px',
      borderBottomRightRadius: '8px',
    },
  }));

  return (
    <TabsContainer>
      <Grid container spacing={1}>
        {tabs.map((tab) => (
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            <LinkCore key={tab.value} to={tab.to}>
              <TabButton
                isSelected={currentValue === tab.value}
                onClick={(e) => onChange(e, tab.value)}
              >
                {tab.label}
              </TabButton>
            </LinkCore>
          </Grid>
        ))}
      </Grid>
    </TabsContainer>
  );
};
